import React from "react";
import { ToggleButtonGroup, ToggleButton, Box } from '@mui/material';


const NestlingRadioPlatform = ({ value, onChange, styleToggle }) => {

  return (
    <>
    <Box sx={{ fontSize: '15px', color:"#406599", pt:'25px'}}>
          Platform
    </Box>
    <Box>
        <ToggleButtonGroup
          color="error"
          size="small"
          value={value}
          exclusive
          onChange={onChange}
          style={styleToggle}
        >
          <ToggleButton value="Topaz" color="info" >Topaz</ToggleButton>
          <ToggleButton value="Amber" color="info">Amber</ToggleButton>
          <ToggleButton value="Redstone" color="info" >Redstone</ToggleButton>
          <ToggleButton value="Qbert" color="info" >Qbert</ToggleButton>
          <ToggleButton value="Obsidian" color="info" >Obsidian</ToggleButton>
          <ToggleButton value="Sapphire" color="info" >Sapphire</ToggleButton>
        </ToggleButtonGroup>
    </Box>
    </>
  );
};

export default NestlingRadioPlatform;
